import { CoreAppState } from '../state/core-app.state';
import { BaseResourceService } from './base-resource.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { RefundItem } from '@prisma/client';
import { RefundItemResourceTypeMappings } from '@aa/nest/resource';
import { refundItemCompositeKeyOrder } from '@aa/nest/resource/objects';

@Injectable()
export class RefundItemService extends BaseResourceService<RefundItemResourceTypeMappings> {
  constructor(
    protected override readonly http: HttpClient,
    protected override readonly store: Store<CoreAppState>,
  ) {
    super(http, store, 'refund-items');
  }
}
